import { Dictionary } from '../../models/utils';
import { InternalShipmentGroup } from '../../models/shipment-group';
import getPalletBoxesFromShipmentGroup from './getPalletBoxesFromShipmentGroup';

export function getShipmentGroupByCarrierAccountKey(
  shipmentGroups: Dictionary<InternalShipmentGroup>,
  carrierAccountKey: string,
) {
  return Object.values(shipmentGroups).find(shipmentGroup => shipmentGroup.carrierAccountKey === carrierAccountKey);
}
export {
  getPalletBoxesFromShipmentGroup,
};
